require('./ctxTable.style.scss');

class CtxTableController {
    constructor($scope, $element, $timeout, $attrs, utilsService) {
        this.$element = $element;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.utilsService = utilsService;

    }

    $onInit() {
        this.tableClass = this.tableClass || 'table-hover';
        this.idKey = this.idKey || 'uuid';
        this.clickable = this.utilsService.setDefault(this.clickable, true);
        this.sortable = this.sortable || !!this.onSort;

        this.$scope.$watchCollection(() => this.selectedItems, selectedItems => {
            this.markSelected(this.items || [], selectedItems || []);
        });
        this.$scope.$watchCollection(() => this.items, items => {
            this.markSelected(items || [], this.selectedItems || []);
        });
        //TODO Watch
        // this.$scope.$watchCollection(() => this.orderBy, items => {
        //     this.markSelected(items, this.selectedItems);
        // });
        this.isResizable = angular.isDefined(this.$attrs.columnsResizable) && (this.$attrs.columnsResizable == '');
        this.eventIdName = this.$attrs.eventIdName;
        this.tableId = this.eventIdName || this.guid();
    }

    guid() {
        return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
    }

    s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }

    markSelected(items, selectedItems) {
        (items || []).forEach(i => i._selected = !!(selectedItems || []).filter(si => si[this.idKey] === i[this.idKey]).length);
    }

    toggleSelected(item, event) {
        this.selectedItems = item._selected ? (this.multiSelect ? (this.selectedItems || []).filter(si => si[this.idKey] !== item[this.idKey]) : [])
            : (this.multiSelect ? (this.selectedItems || []).concat([item]) : [item]);
    }

    setSort(colKey, event) {
        let sortDesc = this.sortCol === colKey;
        this.$element.find('th').removeClass('sort asc desc');
        this.sortCol = sortDesc ? `-${colKey}` : colKey;
        angular.element(event.target).addClass(`sort ${(sortDesc ? 'desc' : 'asc')}`);
        this.orderBy = this.sortCol;
        this.onSort ? this.$timeout(() => this.onSort({ sortBy: this.orderBy = this.sortCol }), 0) : this.items = sortDesc ? _.sortBy(this.items, colKey).reverse() : _.sortBy(this.items, colKey);
    }

    getNetworkTooltipText(network) {
        return network ? 'Public IP : ' + (network.ipConfiguration ? network.ipConfiguration.publicIpType + (network.ipConfiguration.publicIp ? ' (' + network.ipConfiguration.publicIp.name + ')' : '') : '/') +
            '\n\n Private IP : ' + (network.ipConfiguration ? network.ipConfiguration.privateIpType + (network.ipConfiguration.privateIpRange ? ' (' + network.ipConfiguration.privateIpRange + ')' : '') : '/') : '';
    }

}

CtxTableController.$inject = ['$scope', '$element', '$timeout', '$attrs', 'utilsService'];

const ctxTableComponent = {
    controller: CtxTableController,
    scope: {},
    template: require('./ctxTable.template.html'),
    bindings: {
        columnConfig: '<',
        items: '<',
        selectedItems: '=?',
        multiSelect: '<?',
        onSort: '&?',
        orderBy: '=?',
        idKey: '@?',
        responsive: '@?',
        tableClass: '@?',
        clickable: '<?',
        sortable: '@?',
        actionButtons: '<?',
        fixedHeader: '<?'
    }
};

module.exports = ctxTableComponent;


// WEBPACK FOOTER //
// ./src/shared/ctxTable/ctxTable.component.js